export default __webpack_public_path__ + "static/media/icon-internet-password.33518f47.png";